// extracted by mini-css-extract-plugin
export default {"sectionContainer":"AdditionalInsuranceSingleItemContent_sectionContainer__PPIRP"};